import { useState } from "react";
import { Loader2, Package } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../components/ui/dialog";

/** Escolher o item do iFood que corresponde a um produto do Núcleo. */
export default function VincularItemDialog({ product, items, loading, onPick, onClose }) {
  const [q, setQ] = useState("");
  const open = !!product;
  const filtered = (items || []).filter((it) => !q || (it.name || it.itemName || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="max-w-lg max-h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>Vincular produto</DialogTitle>
          <DialogDescription>Qual item do iFood é <b>{product?.name}</b>?</DialogDescription>
        </DialogHeader>
        <Input id="ifood-busca-item" placeholder="Buscar item no cardápio do iFood…" value={q} onChange={(e) => setQ(e.target.value)} className="h-8 text-xs" autoFocus />
        <div className="flex-1 overflow-y-auto space-y-2 min-h-[160px]">
          {loading ? (
            <div className="flex items-center justify-center py-8 text-sm text-muted-foreground"><Loader2 className="w-5 h-5 animate-spin mr-2" /> Lendo o cardápio do iFood…</div>
          ) : filtered.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground"><Package className="w-10 h-10 mx-auto mb-2 opacity-30" /><p className="text-sm">{(items || []).length === 0 ? "O iFood não devolveu itens" : "Nenhum item encontrado"}</p></div>
          ) : filtered.map((item, i) => {
            const price = item.price?.value ?? item.price;
            return (
              <button key={item.id || item.itemId || i} onClick={() => onPick(product, item)}
                className="w-full p-3 rounded-lg border hover:border-red-300 hover:bg-red-50 dark:hover:bg-red-900/10 text-left transition-colors">
                <p className="font-medium text-sm">{item.name || item.itemName || "Item sem nome"}</p>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {item._category_name ? `${item._category_name} · ` : ""}
                  {price ? `R$ ${Number(price > 1000 ? price / 100 : price).toFixed(2).replace(".", ",")} · ` : ""}
                  {item.externalCode ? `código ${String(item.externalCode).slice(0, 8)}` : "sem código"}
                </p>
              </button>
            );
          })}
        </div>
        <div className="flex justify-end"><Button variant="ghost" size="sm" onClick={onClose}>Fechar</Button></div>
      </DialogContent>
    </Dialog>
  );
}
